export default ({
  onReorder,
}) => (args) => {
  if (!args.destination) return

  return onReorder(args)
}
